import React from 'react';
import '../css/card.css';
import '../css/projects.css';
import Seo from './Seo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';

// Liste des projets open source
const projects = [
  {
    name: 'nicocarr04/GDG',
    href: '/gdg',
    description: "This is the source code of a program that I made for a professor that I know, and it makes creating groups much easier. It's not perfect yet because it still has some difficulty putting students in the right places, but it works!",
  },
  {
    name: 'nicocarr04/website-ski-exemple',
    href: '/wski',
    description: 'This is the source code of a website that I made. The design of the website may not be perfect as I am not a graphic designer.',
  },
  {
    name: 'nicocarr04/ProjetAQL-GestionDesNotesEtudiant',
    href: 'https://github.com/nicocarr04/ProjetAQL-GestionDesNotesEtudiant',
    description: 'This is the source code of a program that I made with my colleagues for a school project in the software quality assurance class. It was a great way to learn JavaFX and work with classes and structs.',
  },
];

function Projects() {
  return (
    <div className="card-page">
      <Seo
        title="Projects"
        path="/projects"
        description="Open-source projects by Nicolas Carriere: Group Builder (C#, WinForms), a ski reservation website (HTML, CSS) and a JavaFX student grade manager."
      />
      <section className="card-section">
        <h1>Open Source Projects</h1>
        <div className="card">
          <ul className="project-list">
            {projects.map((project) => {
              const external = project.href.startsWith('http');
              return (
                <li key={project.name}>
                  <a
                    className="project"
                    href={project.href}
                    {...(external && { target: '_blank', rel: 'noopener noreferrer' })}
                  >
                    <span className="project-logo">
                      <FontAwesomeIcon icon={faGithub} />
                    </span>
                    <div className="project-info">
                      <div className="project-title">{project.name}</div>
                      <div className="project-description">{project.description}</div>
                    </div>
                    <span className="project-arrow">
                      <FontAwesomeIcon icon={external ? faArrowUpRightFromSquare : faArrowRight} />
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    </div>
  );
}

export default Projects;
